import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _promoStatusLozengeMa, _promotionStatusDetai;

import { PromotionStatus } from '@atlassian/mpac-api-client';
import { PromotionsFilters } from "./PromotionsTable.types";
export var PromotionsTableHeading = {
  cells: [{
    key: 'promotionName',
    content: 'Promotion name',
    width: 13
  }, {
    key: 'requiredApps',
    content: 'Required apps',
    width: 21
  }, {
    key: 'deployment',
    content: 'Deployment',
    width: 10
  }, {
    key: 'billingCycle',
    content: 'Billing cycle',
    width: 9
  }, {
    key: 'discount',
    content: 'Discount',
    width: 5
  }, {
    key: 'startDate',
    content: 'Start date',
    isSortable: true,
    width: 12
  }, {
    key: 'endDate',
    content: 'End date',
    isSortable: true,
    width: 12
  }, {
    key: 'used',
    content: 'Used',
    width: 8
  }, {
    key: 'status',
    content: 'Status',
    width: 8
  }]
};
export var promoStatusLozengeMap = (_promoStatusLozengeMa = {}, _defineProperty(_promoStatusLozengeMa, PromotionStatus.ENDED_EARLY, 'moved'), _defineProperty(_promoStatusLozengeMa, PromotionStatus.EXPIRED, 'removed'), _defineProperty(_promoStatusLozengeMa, PromotionStatus.ACTIVE, 'success'), _promoStatusLozengeMa);
export var promotionStatusDetailsMap = (_promotionStatusDetai = {}, _defineProperty(_promotionStatusDetai, PromotionStatus.ENDED_EARLY, 'This promotion was ended manually'), _defineProperty(_promotionStatusDetai, PromotionStatus.EXPIRED, 'The end date for this promotion has passed'), _defineProperty(_promotionStatusDetai, PromotionStatus.ACTIVE, 'This promotion is valid for customers to apply'), _promotionStatusDetai);
export var applyHostingTypeFilter = function applyHostingTypeFilter(promotions, hostingType) {
  return promotions.filter(function (promotion) {
    return promotion.hostingType === hostingType;
  });
};
export var applyAppsFilter = function applyAppsFilter(promotions, appKey) {
  return promotions.filter(function (promotion) {
    return promotion.eligibleApps.find(function (eligibleApp) {
      return eligibleApp.key === appKey;
    });
  });
};
export var applyActiveStatusFilter = function applyActiveStatusFilter(promotions) {
  return promotions.filter(function (promotion) {
    return promotion.status === PromotionStatus.ACTIVE;
  });
};
export var applyFilters = function applyFilters(promotions, filters) {
  if (filters.length === 0) {
    return promotions;
  }

  filters.forEach(function (filterBy) {
    if (filterBy.type === PromotionsFilters.APPS) {
      promotions = applyAppsFilter(promotions, filterBy.value);
    }

    if (filterBy.type === PromotionsFilters.HOSTING) {
      promotions = applyHostingTypeFilter(promotions, filterBy.value);
    }

    if (filterBy.type === PromotionsFilters.ACTIVE) {
      promotions = applyActiveStatusFilter(promotions);
    }
  });
  return promotions;
};